import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { DENSITY_COLORMAPS } from './density-colormaps';
import type { DensityFeature } from './density-feature';

@Component({
  selector: 'app-density-settings',
  standalone: true,
  imports: [CommonModule, FormsModule, MatSelectModule],
  templateUrl: './density-settings.component.html',
  styleUrls: ['./density-settings.component.css'],
})
export class DensitySettingsComponent {
  readonly colormaps = (['warm', 'viridis'] as const)
    .map(value => ({ value, label: DENSITY_COLORMAPS[value].label }));
  @Input({ required: true }) feature!: DensityFeature;
}
